








































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* api */
import AreaListApi from '@/app/model/api/areaListApi'
import DistrictDetailApi from '@/app/model/api/districtDetailApi'
import DistrictEditApi from '@/app/model/api/districtEditApi'
import DistrictCreateApi from '@/app/model/api/districtCreateApi'
import DistrictDeleteApi from '@/app/model/api/districtDeleteApi'
/* module */
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    Loading,
    Error409Modal,
    DeleteModal,
    ErrorModal,
    ErrorInfo
  }
})
export default class DistrictCreate extends Vue {
  private districtId: string = ''
  private id: string = ''
  private districtData: any = {}
  private areaList: any = {}
  private districtName: string = ''
  private districtCode: string = ''
  private areaID: number = 0
  private sortNumber: string = ''
  private remarks: string = ''
  private timeStamp: number = 0
  private districtNameErrorMessages: any = ''
  private districtCodeErrorMessages: any = ''
  private areaIDErrorMessages: any = ''
  private sortNumberErrorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  /* 表示非表示 */
  private showLoading: boolean = true
  private editflag: boolean = false
  private showServerErrorModal: boolean = false
  private showConfirmationModal: boolean = false
  private showError409Modal: boolean = false
  private show400ErrorMessage: boolean = false

  created () {
    this.districtId = this.$route.params.district_id
    this.getAreaData()
    this.getDistrictList()
  }

  private getDistrictList () {
    (async () => {
      const routePath = this.$route.path
      if (routePath !== '/master/district/create') {
        this.editflag = true
      }

      if (this.editflag) {
        const result = await DistrictDetailApi.getDistrictDetail(this.districtId)
        if (result.isOk()) {
          this.districtData = result.getPayload()

          this.id = this.districtData.district_id
          this.districtName = this.districtData.district_name
          this.districtCode = this.districtData.district_code
          this.areaID = this.districtData.area_id
          this.sortNumber = this.districtData.sort_number
          this.remarks = this.districtData.remarks
          this.timeStamp = this.districtData.time_stamp

          this.showLoading = false
        } else {
          const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
          if (errorData.status_code === '409') {
            this.showError409Modal = true
          } else {
            this.alertText = errorData.alertText
            this.alertTitle = errorData.alertTitle
            this.show400ErrorMessage = true
            window.scrollTo({ top: 0, behavior: 'auto' })
          }
        }
      } else {
        this.showLoading = false
      }
    })()
  }

  private getAreaData () {
    (async () => {
      const data : any = {
        text: '',
        sortName: 'area_name',
        sort: 'asc'
      }

      const result = await AreaListApi.getAreaList(data)

      if (result.isOk()) {
        const areaData = result.getPayload()
        this.areaList = areaData.areas
        if (this.areaList.length === 0) {
          // エラーアラート表示
          this.alertText = ''
          this.alertTitle = '地域が未登録です。地域を登録してから地区を追加してください。'
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  private districtSave () {
    if (this.editflag) {
      this.districtEdit()
    } else {
      this.districtCreate()
    }
  }

  private async districtEdit () {
    if (!this.isDistrictEdit()) {
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
      return
    }

    const bodyData = {
      district_name: this.districtName,
      district_code: this.districtCode,
      area_id: this.areaID,
      sort_number: Number(this.sortNumber),
      remarks: this.remarks,
      time_stamp: this.timeStamp
    }

    const result = await DistrictEditApi.doDistrictEdit(this.$route.params.district_id, bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '地区編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/district').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  private async districtCreate () {
    /* バリデーションチェック */
    if (!this.isDistrictEdit()) {
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
      return
    }

    const bodyData: any = {
      district_name: this.districtName,
      district_code: this.districtCode,
      area_id: this.areaID,
      sort_number: this.sortNumber,
      remarks: this.remarks
    }

    const result = await DistrictCreateApi.doDistrictCreate(bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '地区登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/district').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'POST', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  /* バリデーション */
  private isDistrictEdit () {
    const districtNameFlag = Validator.validateInputDistrictName('districtNameErrorMessage', this.districtName)
    this.districtNameErrorMessages = Validator.getErrorMessage()

    const districtCodeFlag = Validator.validateInputDistrictCode('districtCodeErrorMessage', this.districtCode)
    this.districtCodeErrorMessages = Validator.getErrorMessage()

    const areaIDFlag = Validator.validateInputAreaID('areaIDErrorMessage', this.areaID)
    this.areaIDErrorMessages = Validator.getErrorMessage()

    const sortNumberFlag = Validator.validateInputSortNumber('sortNumberErrorMessage', String(this.sortNumber))
    this.sortNumberErrorMessages = Validator.getErrorMessage()

    if (!districtNameFlag) {
      return districtNameFlag
    } else if (!districtCodeFlag) {
      return districtCodeFlag
    } else if (!areaIDFlag) {
      return areaIDFlag
    }

    return sortNumberFlag
  }

  /* 地区削除 */
  private doDistrictDelete () {
    (async () => {
      const result = await DistrictDeleteApi.doDistrictDelete(this.$route.params.district_id.toString())

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: '地区を削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/master/district').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showConfirmationModal = false
    })()
  }

  // 半角数字、-、.以外入力制限
  private inputCheck () {
    let before: any = String(this.sortNumber)
    let tmp
    let after: any

    if (before === null) {
      after = null
    } else {
      tmp = before.replace(/[^0-9]/g, '')
      after = parseInt(tmp.split('').join(''))
    }

    if (isNaN(after)) {
      after = ''
    }

    this.sortNumber = after
  }

  private doCancel () {
    this.$router.push('/master/district').catch(e => {})
  }
}
